import {View} from 'backbone';
import template from 'behaviors/properties/main/form-field.ejs';
import restServiceAux from 'RestServiceAux';
import listService  from 'ListService';
import _ from 'lodash';
import eventBus from 'EventBus';
import util from 'util/Util.js';
import constants from 'Constants';

class MainSelectFormFieldView extends View {
    initialize(opts){
        this.options = opts || {};
        this.config = opts.config || {};
        this.formFields = [];
        this.modelField = this.config.modelField || 'formOrReport';
        this.selectedForm = false;
        this.selectedFieldId = '';
        this.template = template;
       
        this.events = {
            'click .refreshFields': 'refreshFields',
            'change #form_field_select': 'selectField'
        };

        if(!this.model.get("formFields")){
            this.model.set("formFields",[], {silent:true});
        }

        if (!util.hasEventListener(eventBus._events, `FORM_ID_CHANGED_${this.model.get('id')}`)) {
           this.listenTo(eventBus,`FORM_ID_CHANGED_${this.model.get('id')}`, this.refreshFields);
        }
        
        if (!util.isEmpty(this.model.get('formId')) && !util.isEmpty(this.model.get('formGUID')) ) {
            this.refreshFields();
        }
    }

    selectField(e){
        const value = e.currentTarget.value;
        this.model.set('formFieldId', listService.getCleanedId( value ), {silent: true});
    }

    refreshFields() {
        const active = this.model.get("refreshProcessActive");
        if (this.model.has('formId') && this.model.has('formGUID') && !util.isTrue(active)) {
            
            this.model.set("refreshProcessActive", true, {silent: true});
            restServiceAux.getFormFieldsPromise(constants.DEFAULT_VALUE, this.model.get('formGUID')).then (
                formFields => {
                    this.model.set("refreshProcessActive", false, {silent: true});
                    this.populateFields(formFields);
                 },  err => this.loadFieldsError(`REJECTED PROMISE ==> loadFormFields`, err)
            );
        }
    }

    loadFieldsError(err){
        console.log(err);
        throw err;
    }

    loadForm(){
        if(this.model.get(this.modelField)){
            this.selectedForm = this.model.get(this.modelField);
        }
    }

    populateFields(fields){
        this.model.set("formFields",fields);
        this.formFields = fields;       
        _.each(this.formFields, (field) => {
            $("#form_field_select").append(`<option value="${listService.cleanId(field['@id'])}" >${field['@Name']}</option>`)
        });

        $('#form_field_select').find('option[value="' + listService.cleanId( this.model.get('formFieldId') ) + '"]').attr('selected', true);
     }

    render(){
        this.$el.html(this.template(this.model.toJSON()));

        this.delegateEvents();
    }
}

export default MainSelectFormFieldView;